import { HttpAxiosRequest } from '../httpAxiosBase'
import { BaseResponseWithData, EntityListWithPagination, PaginacionRequest } from 'src/types/baseEntities'
import {
    UserFilterDTO,
    UserGroupFilterDTO,
    UserGroupListResponseDTO,
    UserGroupUpdateDTO,
    UserInsertDTO,
    UserViewDTO
} from 'src/types/user/userData'

export const HttpUser = {
    getEndpoint: (url: string) => `usuarios${url}`,

    getUserList: (
        paginacion: PaginacionRequest,
        filter?: UserFilterDTO
    ): Promise<EntityListWithPagination<UserViewDTO>> => {
        console.log(filter)

        return HttpAxiosRequest.getWithQueryParamsSerializer(HttpUser.getEndpoint(''), { ...paginacion, ...filter })
    },

    updateUser: (userId: number, user: UserInsertDTO) => {
        return HttpAxiosRequest.put(HttpUser.getEndpoint(`/${userId}`), user)
    },

    insertUser: (user: UserInsertDTO): Promise<BaseResponseWithData<number>> => {
        return HttpAxiosRequest.post(HttpUser.getEndpoint(''), user)
    },

    getGroupsByUser: (userId: number, params?: UserGroupFilterDTO): Promise<UserGroupListResponseDTO> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(HttpUser.getEndpoint(`/${userId}/grupos`), { ...params })
    },

    updateUserGroups: (userId: number, data: UserGroupUpdateDTO) => {
        return HttpAxiosRequest.post(HttpUser.getEndpoint(`/${userId}/grupos`), data)
    },

    deactivateUser: (userId: number) => {
        return HttpAxiosRequest.delete(HttpUser.getEndpoint(`/${userId}`))
    },

    activateUser: (userId: number) => {
        return HttpAxiosRequest.post(HttpUser.getEndpoint(`/${userId}/activar`), {})
    },

    blockUser: (userId: number) => {
        return HttpAxiosRequest.post(HttpUser.getEndpoint(`/${userId}/bloquear`), {})
    },

    unBlockUser: (userId: number) => {
        return HttpAxiosRequest.post(HttpUser.getEndpoint(`/${userId}/desbloquear`), {})
    }
}
